import 'src/app/utils/array.extensions';
import 'src/app/utils/behavior-subject.extensions';
import 'src/app/utils/map.extension';
import 'src/app/utils/observable.extensions';
import 'src/app/utils/replay-subject.extensions';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AccountModule } from './views/account/account.module';
import { NgbActiveModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AuthInterceptor } from './services/interceptors/auth.interceptor';
import { SharedModule } from './views/shared/shared.module';
import { RouteReuseStrategy } from '@angular/router';
import { CacheRouteReuseStrategy } from './services/strategy/cache-route-reuse.strategy';
import { ApplicationSourceInterceptor } from './services/interceptors/application-source-interceptor';
import { NgxFloatUiModule } from 'ngx-float-ui';
import { GoogleMapsModule } from '@angular/google-maps';
import { DashboardComponent } from './views/dashboard/components/dashboard/dashboard.component';
import { SidebarNavComponent } from './views/dashboard/components/sidebar-nav/sidebar-nav.component';
import { SidebarSubItemListComponent } from './views/dashboard/components/sidebar-nav/sidebar-sub-item-list/sidebar-sub-item-list.component';
import { NavItemComponent } from './views/dashboard/components/sidebar-nav/nav-item/nav-item.component';
import { NavSubItemComponent } from './views/dashboard/components/sidebar-nav/nav-sub-item/nav-sub-item.component';
import { SignOutNavItemComponent } from './views/dashboard/components/sidebar-nav/nav-item/sign-out-nav-item/sign-out-nav-item.component';
import { IsDefaultNavItemPipe } from './views/dashboard/components/sidebar-nav/pipe/is-base-nav-item.pipe';
import { IsDefaultNavSubItemPipe } from './views/dashboard/components/sidebar-nav/nav-sub-item/pipes/is-default-nav-sub-item.pipe';
import { IsSignOutNavItemPipe } from './views/dashboard/components/sidebar-nav/pipe/is-sign-out-nav-item.pipe';
import { IsUniversalVariantsSubNavItemPipe } from './views/dashboard/components/sidebar-nav/nav-sub-item/pipes/is-universal-variants-sub-nav-item.pipe';
import { UniversalVariantsSubNavItemComponent } from './views/dashboard/components/sidebar-nav/nav-sub-item/universal-variants-sub-nav-item/universal-variants-sub-nav-item.component';
import { SmartFiltersModule } from './views/smart-filters/smart-filters.module';
import { AuthModule } from './views/auth/auth.module';
import { RxLet } from '@rx-angular/template/let';
import { ToastModule } from './modules/toasts/toast.module';
import { provideRxRenderStrategies } from '@rx-angular/cdk/render-strategies';
import { ProductGroupsSubNavItemComponent } from './views/dashboard/components/sidebar-nav/nav-sub-item/product-groups-sub-nav-item/product-groups-sub-nav-item.component';
import { IsProductGroupSubNavItemPipe } from './views/dashboard/components/sidebar-nav/nav-sub-item/pipes/is-product-group-sub-nav-item.pipe';
import { RxPush } from '@rx-angular/template/push';
import { IsProductsNavItemPipe } from './views/dashboard/components/sidebar-nav/pipe/is-products-nav-item.pipe';
import { ProductsNavItemComponent } from './views/dashboard/components/sidebar-nav/nav-item/products-nav-item/products-nav-item.component';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    SidebarNavComponent,
    SidebarSubItemListComponent,
    NavItemComponent,
    NavSubItemComponent,
    ProductsNavItemComponent,
    SignOutNavItemComponent,
    IsDefaultNavItemPipe,
    IsDefaultNavSubItemPipe,
    IsProductsNavItemPipe,
    IsSignOutNavItemPipe,
    IsUniversalVariantsSubNavItemPipe,
    UniversalVariantsSubNavItemComponent,
    ProductGroupsSubNavItemComponent,
    IsProductGroupSubNavItemPipe
  ],
  bootstrap: [AppComponent],
  imports: [
    // Do not change the order of AppRoutingModule. If you do, it will mess up the base route url redirect!
    AppRoutingModule,
    AuthModule,
    AccountModule,
    BrowserModule,
    BrowserAnimationsModule,
    GoogleMapsModule,
    AppRoutingModule,
    BsDropdownModule,
    NgxFloatUiModule,
    ToastModule,
    SmartFiltersModule,
    SharedModule,
    RxLet,
    RxPush,
    NgbTooltipModule
  ],
  providers: [
    NgbActiveModal,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: RouteReuseStrategy,
      useClass: CacheRouteReuseStrategy
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApplicationSourceInterceptor,
      multi: true
    },
    // This is important. It signals parent components of dom changes, which is required to make rx-angular signal
    // @ViewChild, @ViewChildren, @ContentChild, and @ContentChildren in parent components.
    provideRxRenderStrategies({ parent: true }),
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}
